module.exports = __webpack_public_path__ + "static/media/ic-new-fill.49eb3ca9.svg";